import React from 'react';

const ManagementPage: React.FC = () => {
  return (
    <div />
  );
};

export default ManagementPage;
